module.exports = __webpack_public_path__ + "img/wca_logo.865104fe.svg";